/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Alert, Button, H1, P } from '@decisiv/ui-components';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import PasswordField from '@decisiv/ui-components/lib/components/PasswordField';
import UserArrowRight from '@decisiv/iconix/lib/components/UserArrowRight';
import Key from '@decisiv/iconix/lib/components/Key';
import useLogin from './hooks/useLogin';
import { InputField } from './RequestForm';
import useCheckUsernameSso from './hooks/useCheckUsernameSso';
import { FormsContainer, StyledAlert } from './components/styledComponents';

function ExtraInfo() {
  return (
    <P
      weight="regular"
      shade={1}
      style={{
        fontSize: '12px',
        textAlign: 'center',
        marginTop: '35px',
        fontWeight: '400',
      }}
    >
      By logging into the application you agree to the{' '}
      <a
        href="https://support.dsmp.decisiv.net/hc/en-us/articles/360011094554"
        style={{ textDecoration: 'underline' }}
      >
        {' '}
        Policies & Agreements
      </a>
      .
    </P>
  );
}

function PortalLogin({ dealerId, csrfToken, requestPasswordClick }) {
  const [error, setError] = useState('');
  const [allowPasswordLogin, setAllowPasswordLogin] = useState(false);
  const { loginBody, setLoginBody, postLogin, isDirty } = useLogin(
    dealerId,
    setError,
    csrfToken,
  );
  const { postCheckSso } = useCheckUsernameSso(
    loginBody.identity,
    setAllowPasswordLogin,
    setError,
    csrfToken,
  );

  const onChangeHandler = (e) => {
    setLoginBody({
      ...loginBody,
      [e.target.name]: e.target.value,
    });
  };

  const ButtonsContainer = styled(Flex)`
    justify-content: space-between;
    margin-top: -1px;

    @media screen and (max-width: 320px) {
      flex-direction: column-reverse;

      .btn__element--login-btn {
        margin-bottom: 15px;
      }
    }
  `;

  return (
    <Flex justifyContent="center" alignItems="center" flexDirection="column">
      <FormsContainer>
        <H1>Log In to Portal</H1>
        <Flex
          flexDirection="column"
          style={{
            minWidth: '360px',
          }}
        >
          {error && (
            <StyledAlert>
              <Alert intent="danger" title={error} />
            </StyledAlert>
          )}
          <InputField
            icon={UserArrowRight}
            label="Username or email"
            name="identity"
            required
            onChange={onChangeHandler}
          />
          {allowPasswordLogin && (
            <>
              <PasswordField
                style={{ marginBottom: '10px' }}
                icon={Key}
                name="password"
                required
                onChange={onChangeHandler}
                autoComplete="off"
              />
              <a
                role="button"
                tabIndex={0}
                onClick={() => requestPasswordClick()}
                style={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  marginLeft: 'auto',
                }}
              >
                Forgot password
              </a>
            </>
          )}
          <ButtonsContainer>
            <div className="btn__element--login-btn">
              <Button
                text="Log In"
                onClick={() =>
                  allowPasswordLogin ? postLogin() : postCheckSso()
                }
                disabled={allowPasswordLogin ? isDirty() : !loginBody.identity}
              />
            </div>
          </ButtonsContainer>
        </Flex>
      </FormsContainer>
      <ExtraInfo />
    </Flex>
  );
}

PortalLogin.propTypes = {
  dealerId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  requestPasswordClick: PropTypes.func,
};

PortalLogin.defaultProps = {
  dealerId: '',
  requestPasswordClick: () => {},
};

export default PortalLogin;
